import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axiosInstance, { getAccessToken } from "./api/axiosInstance";

window.Pusher = Pusher;
const reverbKey = process.env.REACT_APP_REVERB_APP_KEY;

if (!reverbKey) {
    window.Echo = null;
    console.warn(
        "[echo] REACT_APP_REVERB_APP_KEY is missing; realtime features are disabled.",
    );
} else {
    console.log("🚀 Inicializace Echo konfigurace...");
    window.Echo = new Echo({
        broadcaster: "reverb",
        key: reverbKey,
        wsHost: process.env.REACT_APP_REVERB_HOST,
        wsPort: process.env.REACT_APP_REVERB_PORT || 8080,
        wssPort: process.env.REACT_APP_REVERB_PORT || 443,
        forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
        enabledTransports: ["ws", "wss"],

        clientEvents: true,

        authorizer: (channel, options) => {
            return {
                authorize: (socketId, callback) => {
                    const token = getAccessToken();

                    if (!token) {
                        callback(true, "Chybí přihlašovací token");
                        return;
                    }

                    axiosInstance
                        .post(
                            "/api/broadcasting/auth",
                            {
                                socket_id: socketId,
                                channel_name: channel.name,
                            },
                            {
                                withCredentials: true,
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    Accept: "application/json",
                                },
                                skipForbiddenRedirect: true,
                            },
                        )
                        .then((response) => callback(false, response.data))
                        .catch((error) => callback(true, error));
                },
            };
        },
    });
}
